module.exports = require("is-plain-object");